import { render } from "./KeypairsTab.vue?vue&type=template&id=a3a5c59c&scoped=true"
import script from "./KeypairsTab.vue?vue&type=script&lang=js"
export * from "./KeypairsTab.vue?vue&type=script&lang=js"

import "./KeypairsTab.vue?vue&type=style&index=0&id=a3a5c59c&lang=scss&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3a5c59c"]])

export default __exports__